/**
 * Returns true if the app is being accessed via the dreamm.live domain.
 * Used to conditionally show email/password login instead of Pi Network login.
 */
export const isDreamLive = (): boolean => {
  return window.location.hostname.includes("dreamm.live");
};
